module.exports = __webpack_public_path__ + "static/media/arrow.fe59049b.svg";